import { AlertType } from '@ge/models/constants';
import dayjs from 'dayjs';


export const TIME_BASED_ICON_CONFIG = {
  [AlertType.DERATE]: {
    startField: 'startTime',
    endField: 'validTo',
  },
};

export const getTimeBasedIconSuffix = (alert) => {
  if (!alert || !alert.type || !alert.typeProperties) return null;

 

  const config = TIME_BASED_ICON_CONFIG[alert.type];
  if (!config) return null;

  const now = dayjs();

  const startVal = alert.typeProperties[config.startField];
  const endVal = alert.typeProperties[config.endField];

  const start = startVal ? dayjs(startVal) : null;
  const end = endVal ? dayjs(endVal) : null;

  if (start && now.isBefore(start)) {
    return '_FUTURE'; 
  }

  if (end && now.isAfter(end)) {
    return '_EXPIRED';
  }

  return ''; 
};


export const isInvalid = (alert) => {
  let output = false;
  switch (alert.type) {
    case AlertType.TEMPORARY_CONFIG_CHANGE:
    case AlertType.NOTAM:
      output = alert.isExpired ? true : false;
      break;
    default:
      output = false;
      break;
  }

  return output;
};
